const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class ApiService {
  constructor() {
    this.authToken = null;
  }

  setAuthToken(token) {
    this.authToken = token;
  }

  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(this.authToken && { Authorization: `Bearer ${this.authToken}` }),
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      
      if (response.status === 401) {
        const isAuthAttempt =
          endpoint.startsWith('/auth/login') || endpoint.startsWith('/auth/register');

        if (!isAuthAttempt) {
          // Expired/invalid session for authenticated endpoints.
          localStorage.removeItem('token');
          this.setAuthToken(null);
        }

        let errorMessage = 'Authentication required';
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorMessage;
        } catch (_) {
          // Ignore parse errors and keep fallback message.
        }

        throw new Error(errorMessage);
      }
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Auth methods
  async register(userData) {
    return this.request('/auth/register', {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  }

  async login(email, password) {
    return this.request('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  }

  async getCurrentUser() {
    return this.request('/auth/me');
  }

  async logout() {
    return this.request('/auth/logout', {
      method: 'POST',
    });
  }

  // Plant methods (all now require authentication)
  async getPlants() {
    return this.request('/plants');
  }

  async createPlant(plant) {
    return this.request('/plants', {
      method: 'POST',
      body: JSON.stringify(plant),
    });
  }

  async updatePlant(id, plant) {
    return this.request(`/plants/${id}`, {
      method: 'PUT',
      body: JSON.stringify(plant),
    });
  }

  async deletePlant(id) {
    return this.request(`/plants/${id}`, {
      method: 'DELETE',
    });
  }

  async waterPlant(id) {
    return this.request(`/plants/${id}/water`, {
      method: 'POST',
    });
  }

  // Note methods
  async addNote(plantId, text) {
    return this.request(`/plants/${plantId}/notes`, {
      method: 'POST',
      body: JSON.stringify({ text }),
    });
  }

  async deleteNote(noteId) {
    return this.request(`/notes/${noteId}`, {
      method: 'DELETE',
    });
  }
}

export default new ApiService();
